import React from "react";
import Layout from "../../components/Layout/Page";
import Hero from "../../components/hero";
import CEOIMAGE from "../../assets/images/ceoImage.jpg";
import MDIMAGE from "../../assets/images/md.jpeg";
import FOUNDERIMAGE from "../../assets/images/founder.jpeg";
import CEOIMG from "../../assets/images/3h_CEO.jpg";
import DIRECTORIMG_1 from "../../assets/images/director1.jpeg";
import DIRECTORIMG_2 from "../../assets/images/director2.jpeg"
import DIRECTORIMG_4 from "../../assets/images/director4.jpeg";
import DIRECTORIMG_3 from "../../assets/images/directorlegal.jpeg";




import {
  MainContainer,
  RightContentContainer,
  InnerLeftContainer,
  ImageContainer,
  Name,
  Position,
  InnerRightContainer,
  Heading,
  DescriptionContainer,
  LeftContentContainer,
  InnerContainerLeft,
  InnerContainerRight,
  BottomContainer,
  InnerTopContainer,
  Heading2,
  Description,
  CardsContainer,
  ReverseOnMobile,
  Card,
  ImageContainer2,
  InformationContainer,
  InnerName,
  InnerPosition,
  Arrow,
  ImageContainer3,
  AboutContainer,
} from "./styled.componrnts";
const AboutUs = () => {
  return (
    <>
      <Layout>
        <Hero
          title="About The Company"
          SubTitle="HHH and Sons Presents a Proud Past And Will Keep The Promise For Days To Come"
        />
        <AboutContainer style={{ padding: "50px 150px 0px 150px" }}>
          <p>
            Haji Hamid Hussain & Sons (3H) has come a long way to symbolize
            commitment, distinction, and professional Excellence by meeting the
            stringent, demanding, and extra ordinary work requirements of high
            engineering national and international importance involving civil,
            electrical, and mechanical works for the last 45 years.<br></br>
            The ever increasing efforts towards attaining better and new
            business ventures have exposed the company to a multitude of
            engineering disciplines. Now it is the company’s prerogative to
            deliver a high level of professionalism in infrastructure, design,
            and environmental areas in addition to strong standing in industrial
            projects of power, roads, motorways, and buildings.<br></br> 3H
            boasts and claims to have a reputation for delivering the project
            ahead of schedule. This has consolidated trust and confidence with
            our business entrepreneurs. The repetition of orders we have been
            getting from the clients is a touchstone of their reliance on 3H and
            a clear emblem of the comfort extended by us.<br></br> 3H has
            enjoyed the reputation of being a trend setter in the ever expanding
            arena of housing and infrastructure in the last 30 years and has
            earned respect and the reputation of being the most recognized name
            in the market. 3H has added value through a useful engineering
            contribution towards the concept of development of housing and
            infrastructure vies-a-vies other disciplines.<br></br>
            Today we stand tall and firm over the strong foundation of
            reputation and trust with a high value and numbers of human and
            electromechanical resources which gives us a distinctive edge over
            the competitors in the market.
          </p>
        </AboutContainer>
        <MainContainer>
          <div style={{ marginTop: "200px" }} className="row container mx-auto">
            <div className="col-md-6 col-8 mx-auto">
              <ImageContainer className="w-100" src={FOUNDERIMAGE} />
              <Name className="w-100 text-center">Haji Hamid Hussain</Name>
              <Position className="w-100 text-center">Founder</Position>
            </div>
            <div className="col-md-6">
              <Heading>Message From The Founder</Heading>
              <DescriptionContainer>
                With immense pleasure I am privileged to present company's
                Brochure Profile. Our optimism and belief in adaptability and
                incorporation of new ideas with the ever-changing time have been
                the catalyst for boning our management and engineering skills.
                As a pre-eminent infrastructure company, established over five
                decades ago, Haji Hamid Hussain & Sons has, over the years,
                strongly anchored itself to Pakistan's development effort.
                <br></br> At the time of its conception the company operated
                solely within the Gilgit Baltistan region, but with the passage
                of time we have expanded the scope of our operations throughout
                the country. In fact, HHH & Sons, as an industry leader in
                engineering construction, currently nurtures projects that span
                across such diverse segments as power, road construction, oil
                and gas pipelines constructions, irrigation and water supply,
                electricity, housing utilities, urban infrastructure and import
                & exports all of which impact the nation of Pakistan, and the
                progress of its people.<br></br> It is my privilege that HHH &
                Sons had the opportunity to work for Pakistan Army during the
                kargil War 1998 as General Order Supplier i.e. Food and
                Emission, I as the Chairman considers this as historical
                achievement of my Group and our experience and collaboration
                with the Army was memorable and outstanding.
              </DescriptionContainer>
            </div>
          </div>

          <ReverseOnMobile className="row container mx-auto">
            <div className="col-md-6 ">
              <Heading>Message From The CEO</Heading>
              <DescriptionContainer>
                With immense pleasure I am privileged to present company's
                Brochure Profile. Our optimism and belief in adaptability and
                incorporation of new ideas with the ever-changing time have been
                the catalyst for boning our management and engineering skills.
                As a pre-eminent infrastructure company, established over five
                decades ago, Haji Hamid Hussain & Sons has, over the years,
                strongly anchored itself to Pakistan's development effort.
                <br></br> At the time of its conception the company operated
                solely within the Gilgit Baltistan region, but with the passage
                of time we have expanded the scope of our operations throughout
                the country. In fact, HHH & Sons, as an industry leader in
                engineering construction, currently nurtures projects that span
                across such diverse segments as power, road construction, oil
                and gas pipelines constructions, irrigation and water supply,
                electricity, housing utilities, urban infrastructure and import
                & exports all of which impact the nation of Pakistan, and the
                progress of its people.<br></br> It is my privilege that HHH &
                Sons had the opportunity to work for Pakistan Army during the
                kargil War 1998 as General Order Supplier i.e. Food and
                Emission, I as the Chairman considers this as historical
                achievement of my Group and our experience and collaboration
                with the Army was memorable and outstanding.
              </DescriptionContainer>
            </div>
            <div className="col-md-6 col-8 mx-auto">
              <ImageContainer3 className="w-100" src={CEOIMG} />
              <Name className="w-100 text-center">SHABBIR HUSSAIN</Name>
              <Position className="w-100 text-center">CEO</Position>
            </div>
          </ReverseOnMobile>
          <div className="row container mx-auto">
            {/* <div className="col-md-6 col-8 mx-auto">
              <ImageContainer className="w-100" src={CEOIMAGE} />
              <Name className="w-100 text-center">Hajid Hamid Hussain</Name>
              <Position className="w-100 text-center">"Founder"</Position>
            </div> */}

            {/* <div className="col-md-6">
              <Heading>Message From The Founder</Heading>
              <DescriptionContainer>
                With immense pleasure I am privileged to present company's
                Brochure Profile. Our optimism and belief in adaptability and
                incorporation of new ideas with the ever-changing time have been
                the catalyst for boning our management and engineering skills.
                As a pre-eminent infrastructure company, established over five
                decades ago, Haji Hamid Hussain & Sons has, over the years,
                strongly anchored itself to Pakistan's development effort.
                <br></br> At the time of its conception the company operated
                solely within the Gilgit Baltistan region, but with the passage
                of time we have expanded the scope of our operations throughout
                the country. In fact, HHH & Sons, as an industry leader in
                engineering construction, currently nurtures projects that span
                across such diverse segments as power, road construction, oil
                and gas pipelines constructions, irrigation and water supply,
                electricity, housing utilities, urban infrastructure and import
                & exports all of which impact the nation of Pakistan, and the
                progress of its people.<br></br> It is my privilege that HHH &
                Sons had the opportunity to work for Pakistan Army during the
                kargil War 1998 as General Order Supplier i.e. Food and
                Emission, I as the Chairman considers this as historical
                achievement of my Group and our experience and collaboration
                with the Army was memorable and outstanding.
              </DescriptionContainer>
            </div> */}
          </div>

          <BottomContainer>
            <InnerTopContainer>
              <Heading2>BOARD OF DIRECTORS</Heading2>
              <Description>
                Our distinguished Board of Directors brings a wealth of industry
                expertise, strategic guidance, and visionary leadership,
                <br></br>steering our company’s vision and mission towards
                excellence and innovation
              </Description>
            </InnerTopContainer>
          </BottomContainer>
          <CardsContainer>
            <Card>
              <ImageContainer2 src={FOUNDERIMAGE} />
              <InformationContainer>
                <InnerName>&rarr; HAJI HAMID HUSSAIN</InnerName>
                <InnerPosition>Chairman</InnerPosition>
              </InformationContainer>
            </Card>
            <Card>
              <ImageContainer2 src={CEOIMG} />
              <InformationContainer>
                <InnerName>&rarr; SHABBIR HUSSAIN</InnerName>
                <InnerPosition>CEO</InnerPosition>
              </InformationContainer>
            </Card>
             <Card>
              <ImageContainer2 src={DIRECTORIMG_2} />
              <InformationContainer>
                <InnerName>&rarr; MUHAMMAD HUSSAIN</InnerName>
                <InnerPosition>Senior Executive Director</InnerPosition>
              </InformationContainer>
            </Card>

            <Card>
              <ImageContainer2 src={DIRECTORIMG_4} />
              <InformationContainer>
                <InnerName>&rarr; SAJJAD HUSSAIN</InnerName>
                <InnerPosition>Senior Executive Director</InnerPosition>
              </InformationContainer>
            </Card>
            <Card>
              <ImageContainer2 src={DIRECTORIMG_1} />
              <InformationContainer>
                <InnerName>&rarr; ASHRAF HUSSAIN</InnerName>
                <InnerPosition>Senior Executive Director</InnerPosition>
              </InformationContainer>
            </Card>
            <Card>
              <ImageContainer2 src={MDIMAGE} />
              <InformationContainer>
                <InnerName>&rarr; ARIF HUSSAIN</InnerName>
                <InnerPosition>Managing Director</InnerPosition>
              </InformationContainer>
            </Card>
            <Card>
              <ImageContainer2 src={DIRECTORIMG_3} />
              <InformationContainer>
                <InnerName>&rarr; ZEESHAN HAIDER</InnerName>
                <InnerPosition>DIRECTOR LEGALS</InnerPosition>
              </InformationContainer>
            </Card>
           
          </CardsContainer>
        </MainContainer>
      </Layout>
    </>
  );
};

export default AboutUs;
